// extracted by mini-css-extract-plugin
export default {"container":"B9M8Mv","title":"iZDN1J","textButton":"aNIYLm"};